import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { api } from "../../lib/api";
import P11AdminLayout from "./P11AdminLayout";
import { useP11Role } from "./P11AdminGuard";
import { P11, fmtDate } from "./p11shared";

// Sessieoverzicht met tellingen + link naar aanwezigheid + officiële verplaatsing (owner).
export default function P11AdminSessions() {
  const role = useP11Role();
  const [items, setItems] = useState(null);
  const [resched, setResched] = useState(null); // session
  const [form, setForm] = useState({ date: "", start_time: "", end_time: "" });
  const [busy, setBusy] = useState(false);

  const load = () => api.get("/project11/admin/sessions").then(({ data }) => setItems(data.items || [])).catch(() => setItems([]));
  useEffect(() => { load(); }, []);

  const doReschedule = async () => {
    if (!form.date) { toast.error("Datum is verplicht"); return; }
    setBusy(true);
    try {
      await api.post(`/project11/admin/sessions/${resched.id}/reschedule`, form);
      toast.success(`Sessie ${String(resched.number).padStart(2, "0")} verplaatst — deelnemers zijn gemaild`);
      setResched(null);
      load();
    } catch (err) { toast.error(err?.response?.data?.detail || "Verplaatsen mislukt"); } finally { setBusy(false); }
  };

  return (
    <P11AdminLayout>
      <div data-testid="p11-admin-sessions">
        <div className="p11-label-yellow">SESSIONS</div>
        <h1 className="p11-h1 text-3xl mt-4 mb-8">08 ORIGINAL SESSIONS.</h1>
        {items === null ? <span className="p11-label">…</span> : (
          <div className="divide-y" style={{ borderColor: P11.border }} data-testid="p11-admin-sessions-list">
            {items.map((s) => (
              <div key={s.id} className="py-4 flex flex-wrap items-center gap-4 px-2 hover:bg-[#171717] transition-colors" data-testid={`p11-admin-session-${s.number}`}>
                <Link to={`/project11/admin/sessions/${s.id}`} className="flex flex-wrap items-center gap-4 flex-1 min-w-56">
                  <span className="p11-mono text-xl w-12" style={{ color: P11.yellow }}>{String(s.number).padStart(2, "0")}</span>
                  <span className="flex-1 min-w-40 text-sm" style={{ color: P11.text }}>
                    {fmtDate(s.date)} · {s.start_time}–{s.end_time}
                    {s.rescheduled_from && <span className="p11-label block mt-1" style={{ color: P11.yellow }}>VERPLAATST VAN {s.rescheduled_from.date}</span>}
                  </span>
                  <span className="p11-label" style={{ color: P11.gray2 }}>{s.reserved_count}/{s.capacity} RESERVED</span>
                  <span className="p11-label" style={{ color: P11.gray2 }}>{s.present} PRESENT · {s.verified} VERIFIED · {s.absent} ABSENT</span>
                </Link>
                {role === "owner" && (
                  <button onClick={() => { setResched(s); setForm({ date: s.date, start_time: s.start_time, end_time: s.end_time }); }} className="p11-label px-3 py-1.5 border" style={{ borderColor: P11.border, color: P11.gray2 }} data-testid={`p11-session-reschedule-${s.number}`}>VERPLAATS</button>
                )}
              </div>
            ))}
          </div>
        )}

        {resched && (
          <div className="fixed inset-0 bg-black/80 z-50 flex items-center justify-center p-4" onClick={() => setResched(null)}>
            <div className="bg-[#080808] border max-w-sm w-full p-8" style={{ borderColor: P11.border }} onClick={(e) => e.stopPropagation()} data-testid="p11-reschedule-modal">
              <div className="p11-label-yellow mb-4">// SESSIE {String(resched.number).padStart(2, "0")} VERPLAATSEN</div>
              <p className="text-sm mb-5" style={{ color: P11.gray2 }}>Organisatorische wijziging — het originele sessie-ID blijft behouden en alle deelnemers ontvangen een e-mail. Er ontstaat nooit een negende sessie.</p>
              <div className="space-y-5">
                <div><label className="p11-label">Nieuwe datum</label><input type="date" value={form.date} onChange={(e) => setForm({ ...form, date: e.target.value })} className="p11-input mt-1" data-testid="p11-reschedule-date" /></div>
                <div className="grid grid-cols-2 gap-4">
                  <div><label className="p11-label">Start</label><input type="time" value={form.start_time} onChange={(e) => setForm({ ...form, start_time: e.target.value })} className="p11-input mt-1" data-testid="p11-reschedule-start" /></div>
                  <div><label className="p11-label">Eind</label><input type="time" value={form.end_time} onChange={(e) => setForm({ ...form, end_time: e.target.value })} className="p11-input mt-1" data-testid="p11-reschedule-end" /></div>
                </div>
              </div>
              <div className="flex justify-end gap-3 mt-6">
                <button onClick={() => setResched(null)} className="p11-btn-ghost" data-testid="p11-reschedule-no">ANNULEREN</button>
                <button onClick={doReschedule} disabled={busy} className="p11-btn" data-testid="p11-reschedule-yes">{busy ? "…" : "VERPLAATSEN"}</button>
              </div>
            </div>
          </div>
        )}
      </div>
    </P11AdminLayout>
  );
}
